import { Platform, useWindowDimensions } from 'react-native';

/**
 * Retorna true quando o app está rodando em web em uma janela larga
 * (tablet landscape / desktop). Em nativo (iOS/Android) sempre retorna false.
 */
export function useIsDesktop(breakpoint: number = 1024): boolean {
  const { width } = useWindowDimensions();
  if (Platform.OS !== 'web') return false;
  return width >= breakpoint;
}
